import { Context } from '@nuxt/types';

export default async ({ $notify, i18n, app }: Context) => {
  // @ts-ignore
  const workbox = await window.$workbox;
  if (workbox) {
    workbox.addEventListener('installed', (event: any) => {
      if (event.isUpdate) {
        $notify.push({
          icon: 'bolt',
          title: i18n.t('notifications.global.new_version_available'),
          timeout: 0,
          callback: () => window.location.reload(),
        });
      }
    });
  }

  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const worker of registrations) {
        // TODO: maybe add this on route navigation?
        setInterval(() => {
          worker.update();
        }, 1000 * 60);
      }
    });
  }
};
